import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon } from 'lucide-react';
import { Section, SectionEyebrow } from './shared';
// 17 — WA SERVICE AREA / LOCAL TRUST · [SEO/GEO] [Journey]
// Physical office in Highgate only. Genuine WA-wide service capability.
const locations = ['Perth', 'Joondalup', 'Midland', 'Mandurah', 'Bunbury', 'Geraldton', 'Albany', 'Kalgoorlie', 'Karratha', 'Port Hedland'];
export function ServiceArea() {
  return <Section id="service-area" data-id="element-333">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-334">
        <div data-id="element-335">
          <div className="overflow-hidden rounded-frame border border-ink/5 shadow-card" data-id="element-336">
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=760&q=70" alt="A warm, welcoming professional office reception in Perth" width={720} height={420} loading="lazy" className="h-56 w-full object-cover md:h-64" data-id="element-337" />
          </div>
          <div className="mt-8" data-id="element-338">
            <SectionEyebrow data-id="element-339">Across Western Australia</SectionEyebrow>
          </div>
          <h2 className="mt-5 font-serif text-[32px] font-medium leading-[1.12] tracking-[-0.015em] text-forest md:text-h2" data-id="element-340">
            Helping Injured People Across Western Australia
          </h2>
          <p className="mt-4 text-body-lg text-slate" data-id="element-341">
            Our heritage office is at 453 Beaufort Street, Highgate — just five
            minutes from the Perth CBD, with free street parking right beside
            us. We assist injured people across Western Australia, and can
            arrange phone, video, home and hospital appointments where getting
            to us is difficult.
          </p>

          <div className="mt-6 flex items-start gap-3 rounded-card border border-gold/25 bg-gold/[0.07] p-6" data-id="element-342">
            <ClockIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} data-id="element-343" />
            <p className="text-body text-ink" data-id="element-344">
              Time limits can apply to injury claims. Getting advice early can
              help preserve evidence and clarify your options.
            </p>
          </div>
        </div>

        <div className="rounded-card border border-ink/5 bg-paper p-7 shadow-card md:p-9" data-id="element-345">
          <div className="flex items-center gap-2" data-id="element-346">
            <MapPinIcon aria-hidden="true" className="h-5 w-5 text-forest" strokeWidth={1.75} data-id="element-347" />
            <h3 className="text-h4 font-semibold text-ink" data-id="element-348">
              Areas we help across WA
            </h3>
          </div>
          <p className="mt-2 text-small text-slate/55" data-id="element-349">
            Service capability — not additional physical offices.
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-350">
            {locations.map(loc => <li key={loc} data-id="element-351">
                <span className="inline-flex rounded-full border border-ink/10 bg-canvas px-3.5 py-1.5 text-small text-ink" data-id="element-352">
                  {loc}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-small text-slate/50" data-id="element-353">
            We service the greater Perth area and regional WA. Dedicated local
            pages cover genuine service areas with useful local content.
          </p>
        </div>
      </div>
    </Section>;
}